import React from 'react'
import { RouteList } from 'config/routes'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import 'assets/styles/main.scss'
import 'i18n'
import { Provider } from 'jotai'
import { SocketContext, socket, setSocketRoomId } from 'utils/socket'
export function App() {
	const routerList = RouteList()
	const router = createBrowserRouter([...routerList])
	return (
		<Provider>
			<SocketContext.Provider
				value={{
					socket: socket ?? { on: () => { }, off: () => { }, emit: () => { } },
					setSocketRoomId,
				}}
			>
				<RouterProvider router={router} />
			</SocketContext.Provider>
		</Provider>
	)
}
